import { Flex, Grid, Page } from "@payping/web-components";
import React from "react";
import classnames from "classnames";

type Props = {
  children: React.ReactNode;
  classNames?: string;
};

const PageComponentForHandlingCrispInMobile: React.FC<Props> = ({ children, classNames }) => {
  const { lg } = Grid.useBreakpoint();

  const Styles = {
    PagePadding: lg ? "!tw-pl-4 !tw-pr-8" : "!tw-p-4",
    FlexContentWrapper: "tw-w-full tw-gap-4 xl:tw-gap-12",
  };

  return (
    <Page className={classnames(["!tw-mb-52", Styles.PagePadding, classNames])}>
      <Flex vertical className={Styles.FlexContentWrapper}>
        {children}
      </Flex>
    </Page>
  );
};

export default PageComponentForHandlingCrispInMobile;
